function Footer() {
  return (
    <div className="p-5 text-center">
      {`Kering ©  ${new Date().getFullYear()} scorm-reader`}
    </div>
  )
}

export default Footer
